// extracted by mini-css-extract-plugin
export default {"container":"SelectDropdown_container__tOsjI","caretContainer":"SelectDropdown_caretContainer__k++7o","red":"SelectDropdown_red__WtM-O"};